export const devUrl =
  process.env.VUE_APP_API_HOST || "https://dev-dot-saliency.appspot.com/";
//export const devUrl = 'https://api.saliency.ai/'
//export const devUrl = 'http://localhost:8000/'
//export const devUrl = 'https://dev-dot-saliency.appspot.com/'
